// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Expln_React_Row = require("@expln/utils/src/main/react-mui-components/Expln_React_Row.bs.js");
var Expln_React_Column = require("@expln/utils/src/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("@expln/utils/src/main/Expln_React_common.bs.js");
var Select = require("@mui/material/Select").default;
var MenuItem = require("@mui/material/MenuItem").default;
var Add = require("@mui/icons-material/Add").default;
var TextField = require("@mui/material/TextField").default;
var IconButton = require("@mui/material/IconButton").default;
var InputLabel = require("@mui/material/InputLabel").default;
var FormControl = require("@mui/material/FormControl").default;
var Delete = require("@mui/icons-material/Delete").default;

function MM_cmp_type_settings(Props) {
  var typeSettings = Props.typeSettings;
  var availableColors = Props.availableColors;
  var onAdd = Props.onAdd;
  var onTypeChange = Props.onTypeChange;
  var onColorChange = Props.onColorChange;
  var onPrefixChange = Props.onPrefixChange;
  var onDelete = Props.onDelete;
  var onRestoreDefaults = Props.onRestoreDefaults;
  var rndColorSelect = function (selectedColor, onNewColorSelected) {
    return React.createElement(FormControl, {
                size: "small",
                children: null
              }, React.createElement(InputLabel, {
                    id: "label-for-color-select",
                    children: "Color"
                  }), React.createElement(Select, {
                    labelId: "label-for-color-select",
                    label: "Color",
                    value: selectedColor,
                    onChange: (function (param) {
                        return Expln_React_common.evt2str(onNewColorSelected, param);
                      }),
                    children: availableColors.map(function (color) {
                          return React.createElement(MenuItem, {
                                      value: color,
                                      children: React.createElement("div", {
                                            style: {
                                              backgroundColor: color,
                                              height: "20px",
                                              width: "50px"
                                            }
                                          }),
                                      key: color
                                    });
                        })
                  }));
  };
  var rndTypeSetting = function (ts) {
    var msg = ts.err;
    return React.createElement(Expln_React_Column.make, {
                children: null,
                key: ts.id
              }, React.createElement(Expln_React_Row.make, {
                    children: null
                  }, React.createElement(TextField, {
                        value: ts.typ,
                        label: "Type",
                        size: "small",
                        style: {
                          width: "100px"
                        },
                        onChange: (function (param) {
                            return Expln_React_common.evt2str((function (__x) {
                                          Curry._2(onTypeChange, ts.id, __x);
                                        }), param);
                          })
                      }), rndColorSelect(ts.color, (function (__x) {
                          Curry._2(onColorChange, ts.id, __x);
                        })), React.createElement(TextField, {
                        value: ts.prefix,
                        label: "Prefix",
                        size: "small",
                        style: {
                          width: "100px"
                        },
                        onChange: (function (param) {
                            return Expln_React_common.evt2str((function (__x) {
                                          Curry._2(onPrefixChange, ts.id, __x);
                                        }), param);
                          })
                      }), React.createElement(IconButton, {
                        onClick: (function (param) {
                            Curry._1(onDelete, ts.id);
                          }),
                        children: React.createElement(Delete, {}),
                        key: "delete-button"
                      })), msg !== undefined ? React.createElement("pre", {
                      style: {
                        color: "red"
                      }
                    }, msg) : null);
  };
  return React.createElement(Expln_React_Column.make, {
              style: {
                marginTop: "5px"
              },
              children: null
            }, typeSettings.map(rndTypeSetting), React.createElement(Expln_React_Row.make, {
                  alignItems: "baseline",
                  children: null
                }, React.createElement(IconButton, {
                      onClick: (function (param) {
                          Curry._1(onAdd, undefined);
                        }),
                      children: React.createElement(Add, {}),
                      key: "add-button"
                    }), React.createElement("span", {
                      style: {
                        color: "grey",
                        cursor: "pointer",
                        fontSize: "0.7em"
                      },
                      onClick: (function (param) {
                          Curry._1(onRestoreDefaults, undefined);
                        })
                    }, "Restore default type settings")));
}

var make = MM_cmp_type_settings;

exports.make = make;
/* react Not a pure module */
